export default Object.freeze({
  bySiteAndDate: [],
  byDate: [],
  bySite: [],
  scheduleStatistics: [],
  byEmployee: [],
  tourLog: [],
  loading: true,
});
